/* src/modules/profile/cards/UserInfoCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import {
  Paper,
} from '@material-ui/core';

import { UserHeader } from '../../../../app/components/user';
import styles from './styles';

class UserInfoCard extends React.Component {
  lol() {}

  render() {
    const { classes, name, email } = this.props;
    return (
      <Paper className={classes.paper}>
        <UserHeader
          name={name}
          email={email}

        />
      </Paper>
    );
  }
}

UserInfoCard.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const { auth: { data: { user: { user: { first, last, email } } } } } = state;
  return {
    name: `${first} ${last}`,
    email,
  };
};

const mapDispatchToProps = {};

export default compose(
  withStyles(styles, { name: 'UserInfoCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(UserInfoCard);



// WEBPACK FOOTER //
// ./src/modules/profile/cards/UserInfoCard/index.js